import React, { useEffect, useState } from 'react';
import images from '../images';
import styles from '../css/NavBar.module.scss'
import { useContextoGlobal } from '../ContextoGlobal';
export const NavBar = ({ itemsNavBar, setShowCarrito }) => {
    const { obtenerCantidadItems } = useContextoGlobal();
    const [cantidadItemsCarrito, setCantidadItemsCarrito] = useState([]);

    useEffect(() => {
        setCantidadItemsCarrito(obtenerCantidadItems)
    }, [obtenerCantidadItems])

    useEffect(() => {
        let url = window.location.pathname;

        itemsNavBar.forEach(e => {
            if (!url.localeCompare(e.url)) {
                document.getElementById(e.id).classList.add(styles.active);

            }
        });
        const elem = document.getElementById('navBar')
        const elem2 = document.getElementById('topNavBar')

        window.onscroll = function () {
            if (window.pageYOffset > elem.offsetTop && !(window.pageYOffset < elem2.offsetTop + elem2.offsetHeight)) {
                elem.classList.add('position-fixed', 'top-0');
            } else {
                elem.classList.remove('position-fixed', 'top-0');
            }
        };
    }, [])
    return (
        <nav id='navBar' class={"navbar navbar-expand-lg bg-white px-5 py-3 " + styles.navBar}>
            <div class="container-fluid px-0">
                <a class="navbar-brand" href="/">
                    <img src={images.logos.logo} alt="" />
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarText">
                    <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
                        {itemsNavBar.map(function (elem) {
                            return (
                                <li class="nav-item">
                                    <a id={elem.id} class={"nav-link p-0 text-black me-4 " + styles.subrayado} aria-current="page" href={elem.url}>{elem.nombre}</a>
                                </li>
                            )
                        })}

                    </ul>
                    <img src={images.icons.perfil} className={'pe-auto ' + styles.imgBtn} alt="" />
                    <div className={styles.contCarrito}>
                        <img src={images.icons.carrito} alt="" onClick={() => setShowCarrito(true)} className={'ms-4 ' + styles.imgBtn} />
                        {cantidadItemsCarrito > 0 ?
                            <div className={styles.cantItems}>
                                <div className={styles.letraCantidad}>
                                    {cantidadItemsCarrito > 9 ? '9+' : cantidadItemsCarrito}
                                </div>
                            </div>
                            :
                            <></>
                        }
                    </div>
                </div>
            </div>
        </nav>
    )

}
